import { Injectable } from '@angular/core';

import { ModalService } from 'src/app/services/core/modal.service';

import { ChooseActionSheetPage } from '../../pages/chooser/choose-action-sheet/choose-action-sheet.page';

@Injectable({
  providedIn: 'root'
})
export class ChooserService {

  constructor(
    private modalService: ModalService,
  ) {
  }

  choose(chooseConfig: chooseConfig, component: any = null) {
    return new Promise(async (resolve, reject) => {

      const chooseModal = await this.modalService.create({
        component: component || ChooseActionSheetPage,
        componentProps: chooseConfig,
        animated: true,
        presentingElement: await this.modalService.getTop(),
        cssClass: 'defaultModal'
      });
      
      chooseModal.onWillDismiss().then((response: any) => {
        resolve(response);
      });

      this.modalService.present(chooseModal);
    });
  }

}
